import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchSearchResults, emptySearchResults, newSearchResults } from '../reviewsInstanceSlice';

import SearchBar from './SearchBar';

const ProductReviewsSearch = ({ ...searchBarProps }) => {

	const {
		sortOrder, pageNumber, pageSize, searchTerm
	} = useSelector((state) => state.productSearchUgc_Reviews);
	const dispatch = useDispatch();
	const handleSearch = (searchText) => {

		if (!searchText) {

			dispatch(emptySearchResults());

		} else if (searchText !== searchTerm) {

			dispatch(newSearchResults(searchText));

		}

	};

	useEffect(() => {

		if (searchTerm) {

			const payload = {
				shortSku: window.shortSku,
				searchTerm,
				sortOrder,
				pageSize,
				pageNumber
			};

			dispatch(fetchSearchResults(payload));

		}

	}, [ pageNumber, searchTerm ]);
	const handleClearSearch = () => {

		dispatch(emptySearchResults());

	};

	return (
		<SearchBar
			instance="reviews"
			handleClearSearch={handleClearSearch}
			handleSearch={handleSearch}
			{...searchBarProps}
		/>
	);

};

export default ProductReviewsSearch;
